import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import _ from 'lodash';
import { useRequest } from '../../../../../hooks';
import { unitInfoListSelAPI } from '../../../../../api/progressLearningAPI';

function UnitSelectBox({ defaultValue, eduCursCd, handleCodeSet }) {
  const initial = { unitCd: '', unitCdNm: '', unitNm: '' };
  const [open, setOpen] = useState(false);
  const [unitCode, setUnitCode] = useState(initial);
  const [unitCodeSel, code, , onReset] = useRequest((eduCursCd) => unitInfoListSelAPI(eduCursCd));

  useEffect(() => {
    if (!defaultValue.unitCd || !code) return;
    const findCode = _.find(code, (o) => o.unitCd === defaultValue.unitCd);
    setUnitCode(findCode);
  }, [defaultValue, code])

  useEffect(() => {
    if (!defaultValue.unitCd) setUnitCode(initial);
    if (!eduCursCd) {
      onReset();
      return;
    };
    unitCodeSel(eduCursCd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eduCursCd]);

  const handleOnOffClick = () => {
    setOpen(!open)
  };

  const handleUnitClick = (item) => {
    console.log("***** 진도학습 - 교과수학 진도 변경")

    if (item.unitCd) setUnitCode(item);
    handleOnOffClick();
    handleCodeSet('unit', {unitCd: item.unitCd, unitNm: item.unitNm});
  }

  return (
    <div className="area area2">
      <div
        className={clsx('new-select m_40', open && 'opened')}
      >
        <div
          className={clsx({
            "selected_txt": true,
            "first": unitCode?.unitNm === ""
          })}
          onClick={handleOnOffClick}
        >
          {
            unitCode?.unitNm !== ""
              ? <span>{`${unitCode?.unitCdNm}${unitCode?.unitNm}`}</span>
              : "단원"
          }
        </div>
        <div className="select_option">
          <ul>
            <li>
              <button
                type="button"
                className={unitCode?.unitNm === "" ? "selected" : ''}
                onClick={() => handleUnitClick(initial)}
              >
                단원
              </button>
            </li>
            {
              code && (
                code.map((item) => (
                  <li key={item.unitCd}>
                    <button
                      type="button"
                      className={unitCode?.unitCd === item.unitCd ? "selected" : ''}
                      onClick={() => handleUnitClick(item)}
                    >
                      {item.unitCdNm} {item.unitNm}
                    </button>
                  </li>
                ))
              )
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default UnitSelectBox;